import { render } from "./StockOpnameView.vue?vue&type=template&id=5a35f70a"
import script from "./StockOpnameView.vue?vue&type=script&lang=js"
export * from "./StockOpnameView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__